module.exports = __webpack_public_path__ + "static/media/Pump-ico.58f16097.svg";